export default function ImpersonationBanner({ userName, onExit }) {
  return (
    <div style={{ background: '#C1272D', color: '#fff', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 13, zIndex: 200, position: 'sticky', top: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <i className="ti ti-eye" style={{ fontSize: 16 }} />
        <span>Viewing as <strong>{userName}</strong> — admin impersonation session (expires in 30 min)</span>
      </div>
      <button onClick={onExit} style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.4)', color: '#fff', padding: '5px 14px', borderRadius: 7, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
        Exit impersonation
      </button>
    </div>
  );
}
